/**
 * Build-time switches for work that ships before it is announced.
 *
 * Read at call time rather than at import, so a component test can turn one
 * on with `vi.stubEnv` without re-importing the module under test.
 */

/**
 * Settings › API keys (task 437). On in every deployed environment since task
 * 442 launched the API in production: `mise run sandbox:web:build`,
 * `deploy-dev` and `deploy-prod` all set it. A local build without it hides
 * the page.
 */
export function apiKeysEnabled(): boolean {
  return import.meta.env.VITE_API_KEYS_ENABLED === "true";
}
